var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "chat-messages" } },
    [
      !_vm.messageSyncRunning
        ? _c("MessageList", {
            attrs: {
              "always-scroll-to-bottom": true,
              colors: _vm.colors,
              "is-colored": true,
              ischatwindow: true,
              messages: _vm.messages,
              participants: _vm.getParticipants(),
              "scroll-top": false,
              "is-whatsapp": !!_vm.contact.lastConversation.whatsappNumber,
              "channel-id": _vm.channelId,
              visitorId: _vm.contact._id,
              contactOwner: _vm.contact.owner,
              debugModeEnabled: _vm.debugModeEnabled,
            },
            on: {
              "reply-comment-action": function ($event) {
                return _vm.$emit("reply-comment-action", $event)
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }